import React from "react";
import { useQueryParams } from "src/hooks/useQueryParams";
import { QueryParamSettingsObject } from "../types";

// the useSearchParamsConverter function takes an array of QueryParamSettingsObject objects
// and returns an object with keys corresponding to the variableName from QueryParamSettingsObject
export const useSearchParamsConverter = <T,>(
  queryParamSettingsObjects: QueryParamSettingsObject[]
): T => {
  // destructure getQueryParam from the useQueryParams hook
  const { getQueryParam } = useQueryParams();

  // use reduce to transform the array of QueryParamSettingsObject objects into a single object
  return queryParamSettingsObjects.reduce((acc, curr) => {
    // destructure properties from the current QueryParamSettingsObject object
    const { key, isMultiple, separator, variableName, defaultValue } = curr;
    // get the value of the query parameter from the URL using getQueryParam
    const value = getQueryParam(key);

    // if isMultiple is true, split the value by the separator
    // and assign the array or defaultValue if there is no such value
    if (isMultiple) {
      const valuesArray = value?.split(separator);
      acc[variableName] = valuesArray || defaultValue;
    } else {
      // Otherwise, assign the value as is
      acc[variableName] = value;
    }

    return acc;
  }, {} as T);
  // can use generic or just ReturnValue (type below)
};

// type ReturnValue = Record<QueryParamValueNames, string[] | RangeTuple | string>;

// EXAMPLE

// const queryParamSettingsObjects: QueryParamSettingsObject[] = [
//   {
//     key: "min-investment",
//     variableName: "minInvestment",
//     isMultiple: true,
//     separator: "-",
//     defaultValue: ["0", "1000"],
//   },
//   {
//     key: "search",
//     variableName:"search",
//   },
// ];

// const result = useSearchParamsConverter(queryParamSettingsObjects);

// result log => { minInvestment: ["0", "1000"], search: "some value" };
